import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface InitFormOptions extends CommonOptions {
    gfvs: undefined | string[];
    hlrng: undefined | boolean;
}

export const initFormCommandDefinition = commandDefinition<"init-form", InitFormOptions>(
    "init-form",
    "init-form",
    optionsDefinition(
        {
            alias: "g",
            name: "gfvs",
            defaultValue: { gfvs: undefined },
            parse: (input: string[]) => ({ gfvs: input }),
            defaultOption: true,
            multiple: true,
            description: "Одна или несколько GFV для которых будет создана заготовка.",
        },
        devModeOption,
        logVerbosityOption,
        {
            name: "hlrng",
            doesNotRequireValue: true,
            defaultValue: { hlrng: false },
            parse: (input: boolean) => ({ hlrng: input ? true : false }),
            description: "Копировать схему rng из highlander.farm.",
        }
    ),
    {
        description: "Создание заготовок для новых форм",
    }
);
